<script>
  import { Route, useNavigate } from "svelte-navigator";
  import { onMount } from "svelte";
  import { beforeUpdate } from "svelte";

  import MobileSideBar from "../layout/MobileSideBar.svelte";
  import SideBar from "../layout/SideBar.svelte";
  import Dialog from "../layout/Dialog.svelte";
  import GeneralLoading from "../layout/GeneralLoading.svelte";
  import Notification from "../layout/Notification.svelte";
  import Header from "../layout/Header.svelte";

  import Dashboard from "./Dashboard.svelte";
  import VideoList from "./VideoList.svelte";
  import VideoDetail from "./VideoDetail.svelte";
  import IAB from "./IAB.svelte";
  import Settings from "./Settings.svelte";
  import DemandPartnersList from "./DemandPartnersList.svelte";
  import DemandPartnerEdit from "./DemandPartnerEdit.svelte";
  import NotFound from "./NotFound.svelte";

  import { authStore, headerDisplayStore } from "../stores/General";
  import { checkAuth } from "../utils/auth";
  import CustomIcon from "../components/CustomIcon.svelte";
  import CampaignAdEdit from "./CampaignAdEdit.svelte";
  import CampaignEdit from "./CampaignEdit.svelte";
  import CampaignDetail from "./CampaignDetail.svelte";
  import CampaignList from "./CampaignList.svelte";
  import PublisherEdit from "./PublisherEdit.svelte";
  import PublisherList from "./PublisherList.svelte";
  import VastEditor from "./VastEditor.svelte";
  import ReportList from "./ReportList.svelte";
  import ReportEdit from "./ReportEdit.svelte";
  import BlackListList from "./BlackListList.svelte";
  import BlackListEdit from "./BlackListEdit.svelte";
  import IabBlackListEdit from "./IABBlackListEdit.svelte";
  import IabBlackListList from "./IABBlackListList.svelte";
  import BidTemplate from "./BidTemplate.svelte";
  import VideoUploadList from "../components/VideoUploadList.svelte";
  import VideoEdit from "./VideoEdit.svelte";

  export let name = "ORIGIN";
  export let navigate = "";
  export let mainRoute = "";
  export let location = "";

  const { isAuthenticated } = authStore;

  FusionCharts.options.license({
    key: "4cE2orxG1H4G1B3A2A2B2B2G3D4F3H3C-22ogF4E2hnI-8bwC1E3frcC1G4B1A8D6C4A3G3H3I2A18A16A6B9B6C6zegD3J2A9oA5A1E3bapA1A7A4C-16ziG2H3H1rjvC8B2E6C2C3H2G3A3C6D6B5iacH3H3JD5uwfB2C1C1J-7nA2AC3C1zduH4B3B7A2B2C2B1D4C1G1B11C1C1E4m==",
    creditLabel: false,
  });

  // toggle menu on mobile
  let showMenu = false;
  let showFullMenu = true;

  onMount(async () => {
    await checkAuth();
  });

  beforeUpdate(async () => {
    const settingsShowFullMenu = JSON.parse(
      localStorage.getItem("om_show_full_menu")
    );
    showFullMenu = settingsShowFullMenu === null ? true : settingsShowFullMenu;
  });

  function toggleMenu(event) {
    showFullMenu = event.detail;
  }

  function onChangeAuth(isAuthenticated) {
    if (isAuthenticated === false) {
      window.location = window.location.origin + "/login";
    }
  }

  $: onChangeAuth($isAuthenticated);
</script>

<!-- This example requires Tailwind CSS v2.0+ -->
{#if $isAuthenticated}
  <div class="h-screen flex bg-white">
    <MobileSideBar
      {showMenu}
      onClose={() => {
        showMenu = false;
      }}
    />
    <SideBar {name} {showFullMenu} />

    <div class="flex flex-col w-0 flex-1 w-full" id="viewport">
      <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
        <button
          on:click={() => (showMenu = true)}
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        >
          <span class="sr-only">Open sidebar</span>
          <!-- Heroicon name: outline/menu -->

          <CustomIcon name="open_sidebar" color="black" />
        </button>
      </div>
      <Header {showFullMenu} on:toggleMenu={toggleMenu} />
      <main class="flex-1 relative bg-white focus:outline-none overflow-auto">
        <div class="max-w-full mx-auto p-5 min-h-full bg-custom-gray">
          <Route path="/" primary={false}>
            <Dashboard />
          </Route>
          <Route path="studio" primary={false}>
            <VideoList />
          </Route>
          <Route path="studio/detail" primary={false}>
            <VideoDetail />
          </Route>
          <Route path="studio/new" primary={false}>
            <VideoEdit />
          </Route>
          <Route path="studio/edit/:id" let:params primary={false}>
            <VideoEdit id={params.id} />
          </Route>
          <Route path="campaign/ad/edit" primary={false}>
            <CampaignAdEdit />
          </Route>
          <Route path="campaign/edit/:id" let:params primary={false}>
            <CampaignEdit id={params.id} />
          </Route>
          <Route path="campaign/new" primary={false}>
            <CampaignEdit />
          </Route>
          <Route path="campaign/detail" primary={false}>
            <CampaignDetail />
          </Route>
          <Route path="campaign" primary={false}>
            <CampaignList />
          </Route>
          <Route path="publisher/edit/:id" let:params primary={false}>
            <PublisherEdit id={params.id} />
          </Route>
          <Route path="publisher/new" primary={false}>
            <PublisherEdit />
          </Route>
          <Route path="publisher" primary={false}>
            <PublisherList />
          </Route>
          <Route path="iab" primary={false}>
            <IAB />
          </Route>
          <Route path="demand_partners" primary={false}>
            <DemandPartnersList />
          </Route>
          <Route path="demand_partners/edit/:id" let:params primary={false}>
            <DemandPartnerEdit id={params.id} />
          </Route>
          <Route path="demand_partners/new" primary={false}>
            <DemandPartnerEdit />
          </Route>
          <Route path="report" primary={false}>
            <ReportList />
          </Route>
          <Route path="report/edit/:id" let:params primary={false}>
            <ReportEdit id={params.id} />
          </Route>
          <Route path="report/edit" primary={false}>
            <ReportEdit />
          </Route>
          <Route path="vast/editor" primary={false}>
            <VastEditor />
          </Route>
          <Route path="/blacklist" primary={false}>
            <BlackListList />
          </Route>
          <Route path="/blacklist/edit/:id" let:params primary={false}>
            <BlackListEdit id={params.id} />
          </Route>
          <Route path="/blacklist/edit" primary={false}>
            <BlackListEdit />
          </Route>
          <Route path="/iab-blacklist" primary={false}>
            <IabBlackListList />
          </Route>
          <Route path="/bid-template" primary={false}>
            <BidTemplate />
          </Route>
          <Route path="/iab-blacklist/edit/:id" let:params primary={false}>
            <IabBlackListEdit id={params.id} />
          </Route>
          <Route path="/iab-blacklist/edit" primary={false}>
            <IabBlackListEdit />
          </Route>
          <Route path="settings" primary={false}>
            <Settings />
          </Route>
          <Route>
            <NotFound />
          </Route>
        </div>
        <GeneralLoading />
      </main>
    </div>
  </div>
  <Dialog />
  <VideoUploadList />
  {#if $headerDisplayStore.notify.length}
    <div
      aria-live="assertive"
      class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-100"
    >
      <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
        {#each $headerDisplayStore.notify as noti}
          <Notification
            notify={noti}
            onClose={headerDisplayStore.HideNotification}
          />
        {/each}
      </div>
    </div>
  {/if}
{/if}
